module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e21225ab4b675bc61eed30cfb510c288.svg";